/**
 *
 * createDateFieldContainer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form/immutable';
import DateField from './DateField';
import * as advancedFormActionCreators from '../actions';

function createDateFieldContainer(formName) {
  class DateFieldContainer extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
    static contextTypes = {
      advancedForm: PropTypes.string.isRequired,
    };
    static propTypes = {
      calculateFieldsValues: PropTypes.func.isRequired,
    };

    handleChange = () => { // eslint-disable-line
      setTimeout(() => this.props.calculateFieldsValues(), 0);
    };

    normalize = (value) => (value !== null ? value.toDate() : null);
    
    render() {
      const {
        calculateFieldsValues, // eslint-disable-line
        ...restProps
      } = this.props;

      return (
        <Field
          {...restProps}
          normalize={this.normalize}
          onChange={this.handleChange}
          component={DateField}
        />
      );
    }
  }

  const mapDispatchToProps = (dispatch) => ({
    calculateFieldsValues: () => dispatch(advancedFormActionCreators.calculateFieldsValues(formName)),
  });

  return connect(null, mapDispatchToProps)(DateFieldContainer);
}

export default createDateFieldContainer;
